import React from 'react';

const IconLeftMenuFooter = (props: { onClick?: () => void }) => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={props?.onClick}
        style={{ cursor: 'pointer' }}
    >
        <mask id="path-1-inside-1_6471_25159" fill="white">
            <path d="M0 6C0 2.68629 2.68629 0 6 0H26C29.3137 0 32 2.68629 32 6V26C32 29.3137 29.3137 32 26 32H6C2.68629 32 0 29.3137 0 26V6Z" />
        </mask>
        <path
            d="M6 1H26V-1H6V1ZM31 6V26H33V6H31ZM26 31H6V33H26V31ZM1 26V6H-1V26H1ZM6 31C3.23858 31 1 28.7614 1 26H-1C-1 29.866 2.13401 33 6 33V31ZM31 26C31 28.7614 28.7614 31 26 31V33C29.866 33 33 29.866 33 26H31ZM26 1C28.7614 1 31 3.23858 31 6H33C33 2.13401 29.866 -1 26 -1V1ZM6 -1C2.13401 -1 -1 2.13401 -1 6H1C1 3.23858 3.23858 1 6 1V-1Z"
            fill="#4D4E65"
            mask="url(#path-1-inside-1_6471_25159)"
        />
        <path
            fillRule="evenodd"
                          clipRule="evenodd"
            d="M14.5852 16.0004L9.95898 11.3742L11.3732 9.95996L15.9994 14.5862L20.6257 9.95996L22.0399 11.3742L17.4136 16.0004L22.0399 20.6266L20.6257 22.0408L15.9994 17.4146L11.3732 22.0408L9.95898 20.6266L14.5852 16.0004Z"
            fill="#4D4E65"
        />
    </svg>
);

export default IconLeftMenuFooter;
